var jade = require("/opt/atlassian/pipelines/agent/build/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<header><header-primary><header-title>{{ 'new' | translateWith:'app' }}</header-title></header-primary></header><div class=\"o-wrapper\"><div class=\"c-panel\"><div ng-form=\"vm.form\" novalidate=\"\" class=\"form layout\"><games-form resource=\"vm.resource\" logo=\"vm.logo\"></games-form></div></div><div class=\"layout layout--right layout--auto\"><div class=\"layout__item\"><a id=\"game-save-btn\" ng-click=\"!(vm.form.$invalid || vm.isResourceBeingPersisted) &amp;&amp; vm.save()\" ng-class=\"{'is-disabled': vm.form.$invalid || vm.isResourceBeingPersisted}\" class=\"o-btn c-btn c-btn--primary\">{{ {create: vm.new, update:!vm.new} | translateWith:'app' }}</a></div></div></div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/games/gamesEdit.jade
 ** module id = 834
 ** module chunks = 0
 **/